module.exports = __webpack_public_path__ + "img/img-1.e1b82534.png";